<template>
  <div class="role">
    <div class="left">
      <div class="search">
        <el-input placeholder="请输入角色名" v-model="roleQuery" prefix-icon="el-icon-search" @keyup.enter.native="search">
          <el-button slot="append" @click="search">搜索</el-button>
        </el-input>
      </div>
      <div class="roleList">
        <div class="roleListTitle">
          <h1>角色列表</h1>
          <auth-button size="medium" code="XZJS" type="text" @click="openRole({ id: 0 })">新增</auth-button>
        </div>
        <ul class="role-list">
          <li v-for="role in roleList" :key="role.id" @mouseenter="roleEnter(role)" @mouseleave="roleLeave"
              @click="currentRole(role)" :class="{ 'check-role': role.id === roleId }">
            <span :title="role.roleName">{{ role.roleName }}</span>
            <div v-show="role.id === hoverRoleId && role.id !== '1' && role.id !== '2'">
              <auth-button icon="el-icon-edit-outline" class="ml-5" size="medium" code="XZJS" type="text" title="修改" @click="openRole(role)" />
              <auth-button icon="el-icon-remove-outline" class="ml-5" size="medium" code="XZJS" type="text" title="删除" @click="deleteRole(role)" />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="right">
      <el-form class="operate-header" @submit.native.prevent :inline="true">
        <el-form-item class="fill-all">
          <auth-button icon="iconfont icon-Save" code="JSGL" type="primary" @click="savePower">保存</auth-button>
          <auth-button icon="iconfont icon-reset" code="JSGL" @click="currentRole({ id: roleId })">恢复默认</auth-button>
        </el-form-item>
      </el-form>
      <div class="power">
        <div class="powerList">权限列表</div>
        <div style="background: #fafbfd">
          <el-tree ref="tree" class="funcList" :data="powerList" show-checkbox check-strictly
                   @node-click="handleNodeClick" node-key="id">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <div>
                <span :class="{ 'top-title': data.parentId == 0 }">{{ data.funcName }}</span>
                <span v-if="data.children" style="margin-left: 16px">
                  <i class="el-icon-arrow-down" v-if="!node.expanded"></i>
                  <i class="el-icon-arrow-up" v-if="node.expanded"></i>
                </span>
              </div>
              <div v-if="data.isViewAuthType > 0 && node.checked && data.funcKey!='ZZJG'&& data.funcKey!='JSGL'&&data.funcKey!='XTSZCD'&& data.funcKey!='ZDGL'">
                <span class="view-title">数据可见范围:</span>
                <el-radio-group v-model="data.isViewAuthType" @click.native.stop :disabled="!!data.disabled">
                  <el-radio :label="1">个人</el-radio>
                  <el-radio :label="2">本部门</el-radio>
                  <el-radio :label="3">本部门及下级部门</el-radio>
                  <el-radio :label="4">所有</el-radio>
                </el-radio-group>
              </div>
            </span>
          </el-tree>
        </div>
      </div>
    </div>
    <el-dialog :title="`${roleType === 'edit' ? '修改' : '新增'}角色`" :visible="roleVisible" :before-close="handleClose"
               width="25%" class="abow_dialog">
      <el-form label-width="100px" @submit.native.prevent :model="roleData" ref="form">
        <el-form-item label="角色名称" prop="roleName" :rules="[{ required: true, trigger: 'blur', message: '请输入角色名称' }]">
          <el-input v-model.trim="roleData.roleName" placeholder="请输入角色名称" maxlength="30"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveRole('form')">确 定</el-button>
        <el-button @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //角色列表
      roleList: [],
      //新增or修改
      roleType: "add",
      //弹窗是否可见
      roleVisible: false,
      //弹窗数据
      roleData: {
        id: 0,
        roleName: "",
      },
      //角色固定id
      roleId: "1",
      //查询角色名称
      roleQuery: "",
      //当前鼠标悬浮角色id
      hoverRoleId: -1,
      //权限列表
      powerList: [],
      //被选中的权限
      checkList: [],
      //当前角色权限
      funcList: [],
    };
  },
  mounted() {
    this.getRoleList();
    this.getPowerList();
  },
  methods: {
    getChilds(arr) {
      return arr.reduce((a, b) => {
        a = a.concat(b);
        if (b.children && b.children.length) {
          return a.concat(this.getChilds(b.children));
        } else {
          return a;
        }
      }, []);
    },
    adminFunc() {
      this.$nextTick(() => {
        let powerLists = this.getChilds(this.powerList).map((p) => {
          if (p.isViewAuthType) {
            p.isViewAuthType = 4;
          }
          p.disabled = true;
          return p;
        });
        this.$refs.tree.setCheckedNodes(powerLists);
      });
    },
    //获取所有权限清单
    getPowerList() {
      this.axios.get("/Crm/Func/FuncTree").then((res) => {
        this.powerList = res;
        if (this.roleId == "1") {
          this.currentRole({id: "1"});
        }
      });
    },
    setDisable(arr) {
      return arr.map((b) => {
        b.disabled = false;
        if (b.isViewAuthType) {
          b.isViewAuthType = 1;
        }
        if (b.children) {
          this.setDisable(b.children);
        }
        return b;
      });
    },
    //获取当前角色权限
    currentRole(row) {
      this.roleId = row.id;
      this.axios.get(`/Crm/Func/FuncByRole?roleId=${row.id}`).then((res) => {
        this.powerList = this.setDisable(this.powerList);
        if (this.roleId == "1") {
          this.adminFunc();
        } else {
          res = res.map((r) => {
            r.id = r.funcId;
            if (r.authType) {
              this.$refs.tree.getNode(r.id).data.isViewAuthType = r.authType;
            }
            return r;
          });
          this.$nextTick(() => {
            this.$refs.tree.setCheckedNodes(res);
          });
        }
      });
    },
    //保存当前角色权限
    savePower() {
      this.funcList = this.$refs.tree.getCheckedNodes().map((t) => {
        t.authType = t.isViewAuthType;
        t.funcId = t.id;
        return t;
      });
      let obj = {
        roleId: this.roleId,
        funcList: this.funcList,
      };
      this.axios.post("Crm/Role/RoleFunc", obj).then(() => {
        this.$message.success("保存成功！");
      });
    },
    handleNodeClick(data, node, arg) {
      // console.log(data, node, arg);
    },
    //1.获取角色列表
    getRoleList() {
      this.axios.get("/Crm/Role/RoleList?RoleName=").then((res) => {
        this.roleList = res;
      });
    },
    //2.判断打开窗口是新增还是修改
    openRole(row) {
      this.roleData.id = 0;
      this.roleData.roleName = "";
      if (row.id) {
        this.roleType = "edit";
        this.roleData = Object.assign({}, row);
      } else {
        this.roleType = "add";
      }
      this.roleVisible = true;
    },
    //3.弹窗关闭
    handleClose() {
      this.roleVisible = false;
      this.$refs.form.clearValidate();
    },
    //4.新增和修改角色
    saveRole(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.roleType === "edit") {
            let obj = {
              id: this.roleData.id,
              roleName: this.roleData.roleName,
            };
            this.axios
                .post(`Crm/Role/ModifyRole`, obj)
                .then(() => {
                  this.$message.success("修改成功！");
                  this.roleVisible = false;
                  this.getRoleList();
                })
                .catch(() => {
                });
          } else {
            this.axios.post(`Crm/Role/AddRole`, this.roleData).then(() => {
              this.$message.success("添加成功！");
              this.roleVisible = false;
              this.getRoleList();
            });
          }
        }
      });
    },
    //5.删除角色
    deleteRole(row) {
      this.$confirm("是否删除该角色", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.axios
                .delete(`Crm/Role/DelRole?roleId=${row.id}`)
                .then(() => {
                  this.$message.success("删除成功！");
                  this.roleId = "1";
                  this.getRoleList();
                })
                .catch(() => {
                });
          })
          .catch(() => {
          });
    },
    //查找角色
    search() {
      this.axios.get(`/Crm/Role/RoleList?RoleName=${this.roleQuery}`).then((res) => {
        this.roleList = res;
        if (!this.roleList.length) {
          this.$message.warning("该角色不存在...");
        }
      });
    },
    //鼠标移入
    roleEnter(role) {
      this.hoverRoleId = role.id;
    },
    //鼠标移出
    roleLeave() {
      this.hoverRoleId = -1;
    },
  },
};
</script>

<style scoped lang="scss">
.role {
  display: flex;
  height: 0;
  overflow-y: auto;

  .left {
    display: flex;
    flex-direction: column;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    border: 1px solid #ebedf3;
    padding: 10px 0;
    width: 220px;
    display: flex;
    padding: 10px;
    flex-direction: column;

    /deep/ .el-input__inner {
      height: 38px;
      line-height: 38px;
      border: 1px solid #d8deeb;
      //border-radius: 11px 0 0 11px;
    }

    .roleList {
      //border: 1px solid #dcdcdc;
      margin-top: 15px;
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow: auto;
      background-color: #fff;
      border-radius: 11px;
      padding: 10px 10px;

      .roleListTitle {
        display: flex;
        justify-content: space-between;
        padding: 5px 0;
        height: 42px;
        line-height: 42px;

        h1 {
          font-size: 14px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: bold;
          color: #000000;
        }

      }

      .role-list {
        max-height: 700px;
        overflow-y: auto;
        flex: 1;

        li {
          display: flex;
          list-style: none;
          height: 36px;
          line-height: 36px;
          font-size: 14px;
          color: #9ca6b8;
          padding: 0 10px;
          cursor: pointer;

          &:hover {
            background-color: #f5f7fa;
          }

          .ml-5 {
            margin-left: 5px !important;
          }

          span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            flex: 1;
          }
        }
      }

      .check-role {
        font-size: 14px;
        font-family: Source Han Sans CN, Source Han Sans CN-Normal;
        color: #2c4057;
        background: #d9e2eb;
        border-radius: 5px;
      }
    }
  }

  .right {
    background-color: #fff;
    flex: 1;
    display: flex;
    flex-direction: column;
    border: 1px solid #ebedf3;
    border-left: none;
    padding-top: 20px;
    box-sizing: border-box;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    display: flex;
    flex-direction: column;

    //.handle {
    //  text-align: right;
    //  margin-bottom: 15px;
    //}

    .power {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow-y: overlay;
      background: #ffffff;

      /deep/ .funcList > div {
        border-bottom: 1px solid #dfe6f1;
      }

      .funcList {
        background: #fafbfd;
        padding: 13px 10px;

        /deep/ .el-tree-node__content {
          height: 60px;
          line-height: 60px;
        }

        /deep/ .el-tree-node__children {
          // width: 65%;
          padding-bottom: 10px;

          .el-tree-node__content {
            height: 35px;
            line-height: 35px;
          }
        }

        /deep/ .el-tree-node__content {
          .el-checkbox .el-checkbox__inner {
            display: none;
          }
        }

        /deep/ .el-tree-node__children {
          .el-checkbox .el-checkbox__inner {
            display: inline-block;
          }
        }

        .top-title {
          font-size: 16px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: bold;
          color: #000000;
        }

        /deep/ .el-tree-node__content {
          .el-tree-node__expand-icon {
            display: none;
          }
        }

        .custom-tree-node {
          display: flex;
          margin-left: 15px;
          // justify-content: space-between;
          flex: 1;
          color: #2c4057;

          .el-radio-group {
            background-color: #fafbfd;
          }
        }
      }

      .powerList {
        height: 63px;
        line-height: 63px;
        padding: 5px 12px;
        border: 1px solid #ebeef5;
        color: #2c4057;
        background-color: #edf3fa;
        font-weight: bold;
        font-size: 14px;
        font-family: Source Han Sans CN, Source Han Sans CN-Medium;
      }
    }
  }

  .view-title {
    display: inline-block;
    margin-left: 30px;
    margin-right: 15px;
  }

  .close {
    display: flex;
    justify-content: flex-end;
  }

  /deep/ .el-collapse-item__header {
    background-color: #f4f4f5;
    padding: 0 15px;
  }

  /deep/ .el-collapse-item__content {
    padding-bottom: 0;
  }

  /deep/ .el-checkbox-group {
    font-size: 16px;
  }

  /deep/ .el-checkbox {
    display: flex;
    margin-right: 0;
  }

  /deep/ .el-checkbox__label {
    flex: 1;
  }

  .operate-header {
    padding: 0 20px;

    .fill-all {
      flex: 1;
      text-align: right;
    }
  }
}
</style>
